export default {
    row1: [
        {
            column: "column1",

            rows: {
                row1: [
                    {
                        name: "marksandno",
                        component: "textarea",
                        width:"70%",
                        // label: "Marks and No's",
                    },


                ],
            }
        }
    ]
}